import React, { useEffect, useState } from "react";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { getAllBalances, selectBalance } from "../../../Infrastructure/Services/BalanceService";
import { toast } from "react-toastify";
import UIButton from "../../../Domain/Components/UI/Button/Button";
import UILabelInput from "../../../Domain/Components/UI/LabelInput/LabelInput";
import { styleType } from "../../../Domain/Constants/StyleType";
import { inputType } from "../../../Domain/Constants/InputType";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import { Link, useNavigate } from "react-router-dom";

function SelectBalancePage(props) {
    const [balances, setBalances] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const token = getWithExpiry("token");

        if (!token) {
            props.setLoggedIn(false);
            return;
        }

        getAllBalances(token).then((data) => {
            if (!data) {
                toast.error("Failed to load balances");   
                return;
            } 
            setBalances(data);
            if (data.length === 0) {
                toast.warning("No balances found. Please create a balance first")
            }
        }).catch((ex) => {
            toast.error(ex);
        })
    }, [])

    const handleSubmit = async(e) => {
        e.preventDefault();

        try {
            let token = getWithExpiry('token');
            if (token === null) {
                props.setLoggedIn(false);
                return;
            }

            const form = e.target;
            const formData = new FormData(form);
            let formJson = Object.fromEntries(formData.entries());

            let success = await selectBalance(formJson.player_balance_id, token);

            if (success) {
                toast.success("Balance selected successfully");
                navigate("/game");
            }
        } catch (ex) {
            toast.error(ex)
        }
    }
    return(<>
        {balances &&
            <div className="container">
                <div className="d-flex justify-content-between mt-2">
                    <h3>Select Balance</h3>
                    <Link to="/balance/create" className="btn btn-fadeblack">Create New Balance</Link>
                </div>
                <form className="mt-2" method="post" onSubmit={handleSubmit}>

                    <UILabelInput inputType={inputType.SELECT}
                        inputId={"player_balance_id"}
                        labelText={"Balance"}
                        required={true}
                        selectOptions={formatArrayForSelectInput(balances, "currency.iso_code~real_balance~bonus_balance")}
                        defaultValue={balances.filter(x => x.is_active)[0]?.id} />

                    <div className="d-flex justify-content-end mt-2">
                        <UIButton buttonType={"submit"} buttonText={"Select"} styleType={styleType.FLEXPINK} />
                    </div>
                </form>

            </div>
        }
    </>)
}

export default SelectBalancePage;